import { Dispatch } from '@reduxjs/toolkit';
import { TileSettings } from '../../../../types/tileBuilderTypes';

export interface ChartControlProps {
  chartId: string;
  settings: TileSettings;
  dispatch: Dispatch;
  chartKind: string;
  isLineChart?: boolean;
  derivedFields?: string[];
}

export const GROUP_MODES = [
  { value: 'stacked', label: 'Stacked' },
  { value: 'grouped', label: 'Grouped' },
];

export const LAYOUTS = [
  { value: 'vertical', label: 'Vertical' },
  { value: 'horizontal', label: 'Horizontal' },
];

export const LEGEND_ANCHORS = [
  { value: 'bottom', label: 'Bottom' },
  { value: 'left', label: 'Left' },
  { value: 'top-left', label: 'Top-Left' },
  { value: 'top-right', label: 'Top-Right' },
  { value: 'bottom-left', label: 'Bottom-Left' },
  { value: 'bottom-right', label: 'Bottom-Right' },
  { value: 'top', label: 'Top' },
  { value: 'right', label: 'Right' },
  { value: 'center', label: 'Center' },
];

export const LEGEND_DIRECTIONS = [
  { value: 'row', label: 'Row' },
  { value: 'column', label: 'Column' },
];

export const LINE_CURVES = [
  'linear',
  'basis',
  'cardinal',
  'catmullRom',
  'monotoneX',
  'monotoneY',
  'natural',
  'step',
  'stepAfter',
  'stepBefore',
] as const;

export const SCALE_TYPES = ['linear', 'point', 'time'] as const;

export const SLICE_OPTIONS = [
  { value: '', label: 'None' },
  { value: 'x', label: 'X' },
  { value: 'y', label: 'Y' },
];

export const LABEL_POSITIONS = [
  { value: 'start', label: 'Start' },
  { value: 'middle', label: 'Middle' },
  { value: 'end', label: 'End' },
];

export const LABEL_TEXT_COLORS = [
  { value: 'inherit', label: 'Inherit' },
  { value: 'theme', label: 'Theme' },
  { value: 'custom', label: 'Custom' },
];

export const COLOR_SCHEMES = [
  { value: 'nivo', label: 'Nivo / Magnetic Default' },
  { value: 'category10', label: 'Category10' },
  { value: 'accent', label: 'Accent' },
  { value: 'dark2', label: 'Dark2' },
  { value: 'paired', label: 'Paired' },
  { value: 'pastel1', label: 'Pastel1' },
  { value: 'pastel2', label: 'Pastel2' },
  { value: 'set1', label: 'Set1' },
  { value: 'set2', label: 'Set2' },
  { value: 'set3', label: 'Set3' },
  { value: 'blues', label: 'Blues' },
  { value: 'greens', label: 'Greens' },
  { value: 'greys', label: 'Greys' },
  { value: 'oranges', label: 'Oranges' },
  { value: 'purples', label: 'Purples' },
  { value: 'reds', label: 'Reds' },
  { value: 'spectral', label: 'Spectral' },
];

export const CHART_DATE_RANGE_NAMES = [
  { value: 'all', label: 'All Time' },
  { value: 'previous_calendar_year', label: 'Previous Calendar Year' },
  { value: 'current_fiscal_year', label: 'Current Fiscal Year' },
  { value: 'last_quarter', label: 'Last Quarter' },
  { value: 'past_1_quarters', label: 'Past 1 Quarter' },
  { value: 'past_2_quarters', label: 'Past 2 Quarters' },
  { value: 'past_3_quarters', label: 'Past 3 Quarters' },
  { value: 'past_4_quarters', label: 'Past 4 Quarters' },
  { value: 'past_5_quarters', label: 'Past 5 Quarters' },
  { value: 'past_6_quarters', label: 'Past 6 Quarters' },
];